<template>
  <div class="ai-profile-fill">
    <h3>建议更新画像<span v-if="rows.length"> · {{ rows.length }} 项</span></h3>
    <p v-if="!Array.isArray(result.profile_updates)" class="ai-caption">这份历史分析还没有画像选项建议，可重新分析后生成。</p>
    <p v-else-if="!rows.length" class="ai-caption">暂无可明确更新的画像选项，已有内容保持不变。</p>
    <template v-else>
      <p class="ai-caption">勾选需要采用的项。已有内容和待核实建议不会默认覆盖。</p>
      <p v-if="stale" class="notice">当前资料或跟进已变化，请重新分析后再填入画像。</p>
      <article v-for="row in rows" :key="row.field" class="ai-profile-choice">
        <label class="ai-profile-pick">
          <input v-model="selected" type="checkbox" :value="row.field" :disabled="disabled || stale" />
          <span><b>{{ row.label }}</b><small v-if="row.conflict">将替换已有选项</small><small v-else-if="row.review">需要核实</small><small v-else>可补全</small></span>
        </label>
        <p class="ai-profile-diff"><span>当前：{{ row.currentLabel }}</span><strong>建议：{{ row.valueLabel }}</strong></p>
        <p v-if="row.reason" class="ai-secondary">{{ row.reason }}</p>
        <p v-for="(reference, index) in row.quotes" :key="index" class="ai-profile-quote">“{{ reference.quote }}”</p>
        <ai-evidence :refs="row.evidence" :sources="result.sources" />
      </article>
      <button v-if="!hideAction" class="button full soft" type="button" :disabled="disabled || stale || !selected.length" @click="apply">{{ detail ? '到表单核对画像' : '填入已选画像' }}{{ selected.length ? '（' + selected.length + '）' : '' }}</button>
      <p class="ai-caption">填入后仍可修改，保存表单后才会更新客户资料。</p>
    </template>
  </div>
</template>
<script>
import AiEvidence from './ai-evidence'
import { profileRows } from '../common/ai-profile'
export default {
  components: { AiEvidence },
  props: {
    result: { type: Object, required: true },
    values: { type: Object, default: () => ({}) },
    choices: { type: Object, default: () => ({}) },
    initialFields: { type: Array, default: null },
    onlyFields: { type: Array, default: null },
    disabled: Boolean, stale: Boolean, detail: Boolean, hideAction: Boolean
  },
  data() { return { selected: [] } },
  computed: { rows() { return profileRows(this.result, this.values, this.choices, this.onlyFields) } },
  watch: {
    rows: {
      immediate: true,
      handler(rows) {
        this.selected = rows.filter(row => this.initialFields ? this.initialFields.indexOf(row.field) >= 0 : !row.conflict && !row.review).map(row => row.field)
        this.reportSelection()
      }
    },
    selected() { this.reportSelection() }
  },
  methods: {
    reportSelection() { this.$emit('selection', { count: this.rows.filter(row => this.selected.indexOf(row.field) >= 0).length }) },
    apply() {
      if (this.disabled || this.stale) return
      const rows = this.rows.filter(row => this.selected.indexOf(row.field) >= 0)
      if (!rows.length) return
      const expected = {}
      rows.forEach(row => { expected[row.field] = row.current })
      this.$emit('apply', { analysisId: this.result.id, updates: rows.map(row => ({ field: row.field, value: row.value })), expected })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customer-ai-profile.vue